export default __webpack_public_path__ + "static/media/ic_marker_current.8bd88a03.svg";